import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OfferDto } from '../../../../api/models/offer-dto';
import { CalculationDto } from '../../../../api/models/calculation-dto';
import { setCalculationPartialPayment, setPartialPayment } from '../../../calculation/calculation.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.state';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'contact-payment-amount',
  templateUrl: './payment-amount.component.html',
  styleUrls: ['./payment-amount.component.scss'],
})
export class PaymentAmountComponent implements OnInit, OnDestroy {
  calculation!: CalculationDto | undefined;
  partialPayment = false;

  @Input()
  offerSubject!: BehaviorSubject<OfferDto | null>;

  @Input()
  customerType!: string;

  offer: OfferDto | null = null;

  constructor(private readonly store: Store<AppState>) {}

  ngOnInit() {
    this.offerSubject.subscribe((offer) => {
      this.offer = offer;
    });
  }

  ngOnDestroy() {
    this.offerSubject.unsubscribe();
  }

  getPartialPaymentAmount(): number {
    if (!this.offer) {
      return 0;
    }
    return this.customerType === 'juridica' ? this.offer.companyPartialAmount : this.offer.partialAmount;
  }

  getPaymentAmountLeft(): number {
    if (!this.offer) {
      return 0;
    }
    return this.offer.discountedTotal - this.getPartialPaymentAmount();
  }

  async updatePaymentType() {
    this.store.dispatch(setPartialPayment({ partialPayment: this.partialPayment }));
    this.store.dispatch(setCalculationPartialPayment({ partialPayment: this.partialPayment }));
  }
}
